// Used to store detailed service information for each service card
// Used in src/pages/service/components/ServiceGrid.js

const ServiceInfo = [
    {
        id: 1,
        ServiceImg: 'service-card-01.jpeg',
        ServiceName: 'Personal Interior Guidebook',
        price: 'Whole Home: HK$ 50,000 | Open Plan (Living and Kitchen): HK$ 10,000 | Per Room: HK$ 5000',
        details: 'Elevate and reigine your space with a personalized design guidebook crafted by our expert designers. Take a hands-on approach and source items at your own pace and price point.',
        included: [
            '30-min Personalized Design Consultation',
            'Design',
            'Direction Guide',
            'Bespoke Plan Layout',
            'Detailed Moodboard',
            'Sizing Recommendations',
            'Material and Funiture Recommendations',
            'Resource List for Suppliers',
        ],
        journeyId: "journey1"
    },

    {
        id: 2,
        ServiceImg: 'service-card-02.webp',
        ServiceName: 'Full-Service Interior Decoration',
        price: 'Whole Home: HK$ 70,000 | Open Plan (Living and Kitchen): HK$ 20,000 | Per Room: HK$ 10,000',
        details: 'Experience the ultimate in convenience and style with our Full-Service Interior Decoration. We manage the entire process, from concept to completion, ensuring a seamless transformation of your space.',
        included: [
            '30-min Personalized Design Consultation',
            'Comprehensive Design Proposal',
            'Custom Furnishing Layout',
            'Detailed Moodboard',
            '2 Rounds of Design Revisions',
            'Fully Styled and Decorated Space',
            'Detailed Itemized Budget List',
            'Procurement of All Necessaty Items',
            'Project Management - Contract with Contractor',
            'Follow-up - Ongoing Support',
        ],
        journeyId: "journey2"
    },

    {
        id: 3,
        ServiceImg: 'service-card-03.jpg',
        ServiceName: 'Personal Exterior Guidebook',
        price: 'Rooftop: HK$ 20,000 | Garden: HK$ 25,000',
        details: 'Transform your home and extend it to the outdoors with our specialized rooftop and garden designs. Our landscape architects create a tranquil oasis that blends beauty and practicality, enhancing your living experience.',
        included: [
            '30-min Personalized Design Consultation',
            'Design Direction Guide',
            'Bespoke Plan Layout',
            'Detailed Moodboard',
            'Material and Plant Selection Recommendations',
            'Lighting and Furniture recommendations',
            'Maintenance Guidelines'
        ],
        journeyId: "journey1"
    },

    {
        id: 4,
        ServiceImg: 'service-card-04.jpg',
        ServiceName: 'Full-Service Exterior Decoration',
        price:  'Rooftop: HK$ 30,000 | Garden: HK$ 45,000',
        details: 'Discover effortless transformation with our Full-Service Exterior Decoration. We handle every detail from concept to completion, guaranteeing a smooth and stunning enhancement of your outdoor spaces.',
        included: [
            '30-min Personalized Design Consultation',
            'Comprehensive Design Proposal',
            'Bespoke Plan Layout',
            'Detailed Moodboard',
            '2 Rounds of Design Revisions',
            'Fully Styled and Decorated Space',
            'Detailed Itemized Budget List',
            'Procurement of All Necessary Items',
            'Coordination of Installation and Landscaping',
            'Project Management - Contract with Contractor',
            'Follow-up - Ongoing Support',
        ],
        journeyId: "journey2"
    },
    
];

export default ServiceInfo;